var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    id: "openai",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0.463,
    fill: "url(#paint0_linear_302_5110)",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.24713 6.98688C7.54382 5.28988 9.02514 4 10.807 4C11.7269 4 12.5663 4.34338 13.2045 4.90971C13.1432 4.94133 13.0824 4.97455 13.0222 5.00936L8.88898 7.39564C8.77613 7.4608 8.70685 7.58143 8.70743 7.71174L8.73121 13.0549L7.19297 12.1759V7.61401C7.19297 7.39984 7.21156 7.19032 7.24713 6.98688ZM18.3221 6.96114C18.7821 7.75781 18.9044 8.65647 18.733 9.49235C18.675 9.4551 18.6158 9.41904 18.5555 9.38422L14.4224 6.99794C14.3095 6.93278 14.1704 6.93309 14.0579 6.99875L9.4425 9.69089L9.43462 7.91924L13.3853 5.63832C13.5708 5.53122 13.7616 5.44254 13.9556 5.37162C15.5735 4.78013 17.4312 5.41804 18.3221 6.96114ZM9.45933 13.4709L9.44624 10.5295L11.987 9.04745L14.5409 10.5068L14.554 13.4483L12.0132 14.9303L9.45933 13.4709ZM17.3505 11.2759L12.7114 8.62492L14.2418 7.73226L18.1924 10.0132C18.3779 10.1203 18.5501 10.2412 18.7086 10.3737C20.0298 11.4792 20.4061 13.4069 19.5152 14.95C19.0553 15.7467 18.3382 16.302 17.5286 16.5715C17.5319 16.5026 17.5336 16.4334 17.5336 16.3637V11.5912C17.5336 11.4609 17.4637 11.3405 17.3505 11.2759ZM15.2928 16.266L15.269 10.9229L16.8073 11.8018V16.3637C16.8073 16.5779 16.7887 16.7875 16.7531 16.991C16.4564 18.6879 14.9751 19.9777 13.1933 19.9777C12.2733 19.9777 11.4339 19.6343 10.7957 19.068C10.857 19.0364 10.9178 19.0032 10.9781 18.9684L15.1113 16.5821C15.2241 16.5169 15.2934 16.3963 15.2928 16.266ZM9.94215 16.9791L14.5578 14.2868L14.5656 16.0585L10.615 18.3394C10.4295 18.4465 10.2387 18.5352 10.0447 18.6061C8.42671 19.1976 6.56904 18.5597 5.67814 17.0166C5.21823 16.22 5.09587 15.3214 5.26713 14.4857C5.3251 14.5229 5.38421 14.5589 5.44446 14.5937L9.57762 16.9799C9.69047 17.0451 9.82959 17.0448 9.94215 16.9791ZM6.64968 12.7018L11.2889 15.3528L9.75825 16.2456L5.80759 13.9647C5.62213 13.8576 5.44998 13.7368 5.29159 13.6043C3.97026 12.4988 3.59384 10.571 4.48477 9.02788C4.94476 8.23114 5.66195 7.67583 6.4716 7.40631C6.46835 7.47515 6.46671 7.5444 6.46671 7.61401V12.3866C6.46671 12.5169 6.53653 12.6372 6.64968 12.7018Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_5110",
    x1: 0.463,
    x2: 24.463,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenai);
export default __webpack_public_path__ + "static/media/openai.c1abfa7045226e34d664975ee2e5acda.svg";
export { ForwardRef as ReactComponent };